var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.company.buyer)?_c('Buyer'):_vm._e(),(_vm.company.seller)?_c('Seller'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }